import React from "react";

import AccountingDashboard from "./AccountingDashboard";
import FinancialYear from "./FinancialYear";
import ChartOfAccounts from "./ChartOfAccounts";
import Contacts from "./Contacts";
import ContactStatement from "./ContactStatement";
import JournalEntries from "./JournalEntries";
import ContraManagement from "./ContraManagement";
import NewJournalEntry from "./NewJournalEntry";
import JournalDetail from "./JournalDetail";
import Invoices from "./Invoices";
import NewInvoice from "./NewInvoice";
import InvoiceAging from "./InvoiceAging";
import SalesItems from "./SalesItems";
import PurchaseItems from "./PurchaseItems";
import Vouchers from "./Vouchers";
import NewVoucher from "./NewVoucher";
import VoucherDetail from "./VoucherDetail";
import GeneralLedger from "./GeneralLedger";
import FinancialReports from "./FinancialReports";
import Budget from "./Budget";
import BudgetNew from "./BudgetNew";
import BudgetVsActual from "./BudgetVsActual";
import BankReconciliation from "./BankReconciliation";
import ManualBankReconciliation from "./ManualBankReconciliation";
import LedgerApprovals from "./LedgerApprovals";
import ApprovalWorkflows from "./ApprovalWorkflows";
import ManagerialAccounting from "./ManagerialAccounting";
import PeriodReports from "./PeriodReports";
import SubscriptionBilling from "./SubscriptionBilling";
import AuditTrail from "./AuditTrail";
import RecordKeeper from "./RecordKeeper";
import SystemConfig from "./SystemConfig";
import FixedAssets from "./FixedAssets";
import Liabilities from "./Liabilities";
import Projects from "./Projects";
import YearClose from "./YearClose";
import MigrationAssistant from "./MigrationAssistant";
import Payroll from "./Payroll";
import EmployeeDetail from "./EmployeeDetail";
import PayrollRunDetail from "./PayrollRunDetail";
import TaxFilings from "./TaxFilings";
import StaffAdvances from "./StaffAdvances";
import ApiKeys from "./ApiKeys";
import UserGuide from "./UserGuide";

/**
 * Every page inside the accounting system, and the path it answers on.
 *
 * Kept as data rather than seventy <Route> elements pasted into the main
 * router: the app router maps over this list, so adding an accounting page
 * is one line here and nothing at all in App.jsx.
 */
const ACCOUNTING_ROUTES = [
  // The landing page for the whole module. It lives at "/" in the system these
  // pages came from, which owns the entire app there; here accounting is a room
  // inside a larger building, so its front door is /accounting.
  { path: "/accounting", element: <AccountingDashboard /> },
  { path: "/accounting/financial-year", element: <FinancialYear /> },
  { path: "/accounting/accounts", element: <ChartOfAccounts /> },
  { path: "/accounting/contacts", element: <Contacts /> },
  { path: "/accounting/contacts/:id/statement", element: <ContactStatement /> },
  { path: "/accounting/config", element: <SystemConfig /> },
  { path: "/accounting/journal", element: <JournalEntries /> },
  { path: "/accounting/journal/contra", element: <ContraManagement /> },
  { path: "/accounting/journal/new", element: <NewJournalEntry /> },
  { path: "/accounting/journal/:id", element: <JournalDetail /> },
  { path: "/accounting/invoices", element: <Invoices /> },
  { path: "/accounting/invoices/new", element: <NewInvoice /> },
  { path: "/accounting/invoices/aging", element: <InvoiceAging /> },
  { path: "/accounting/items/sales", element: <SalesItems /> },
  { path: "/accounting/items/purchase", element: <PurchaseItems /> },
  { path: "/accounting/vouchers", element: <Vouchers /> },
  { path: "/accounting/vouchers/new", element: <NewVoucher /> },
  { path: "/accounting/vouchers/:id", element: <VoucherDetail /> },
  { path: "/accounting/assets", element: <FixedAssets /> },
  { path: "/accounting/assets/depreciate", element: <FixedAssets /> },
  { path: "/accounting/assets/appreciate", element: <FixedAssets /> },
  { path: "/accounting/liabilities", element: <Liabilities /> },
  { path: "/accounting/ledger", element: <GeneralLedger /> },
  { path: "/accounting/reports/:type", element: <FinancialReports /> },
  { path: "/accounting/budget", element: <Budget /> },
  { path: "/accounting/budget/new", element: <BudgetNew /> },
  { path: "/accounting/budget/vs-actual", element: <BudgetVsActual /> },
  { path: "/accounting/budget/:id", element: <Budget /> },
  { path: "/accounting/budget/:id/vs-actual", element: <BudgetVsActual /> },
  { path: "/accounting/projects", element: <Projects /> },
  { path: "/accounting/bank/manual-reconcile", element: <ManualBankReconciliation /> },
  { path: "/accounting/bank/reconcile", element: <BankReconciliation /> },
  { path: "/accounting/bank/import", element: <BankReconciliation /> },
  { path: "/accounting/payroll", element: <Payroll /> },
  { path: "/accounting/payroll/advances", element: <StaffAdvances /> },
  { path: "/accounting/payroll/employee/:id", element: <EmployeeDetail /> },
  { path: "/accounting/payroll/run/:id", element: <PayrollRunDetail /> },
  { path: "/accounting/tax", element: <TaxFilings /> },
  { path: "/accounting/integration/keys", element: <ApiKeys /> },
  { path: "/accounting/guide", element: <UserGuide /> },
  { path: "/accounting/year-close", element: <YearClose /> },
  { path: "/accounting/migration", element: <MigrationAssistant /> },
  { path: "/accounting/audit", element: <AuditTrail /> },
  { path: "/accounting/records", element: <RecordKeeper /> },
  { path: "/accounting/approvals", element: <LedgerApprovals /> },
  { path: "/accounting/approvals/workflows", element: <ApprovalWorkflows /> },
  { path: "/accounting/managerial", element: <ManagerialAccounting /> },
  { path: "/accounting/period-reports", element: <PeriodReports /> },
  { path: "/accounting/subscriptions", element: <SubscriptionBilling /> },
];

export default ACCOUNTING_ROUTES;
